(function() {
    angular
        .module("dashboard")
        .controller(
            "OrderUpNotEnabledModalController",
            [
                "$scope",
                "$uibModalInstance",
                "callback",
                OrderUpNotEnabledModalController
            ]
        );

    function OrderUpNotEnabledModalController(
        $scope,
        $uibModalInstance,
        callback
    ) {
        $scope.reload = function () {
            callback();
            $uibModalInstance.close();
        }
    }
})();
